import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
	faArrowRight,
	faBan,
	faChartLine,
	faCheck,
	faCommentDots,
	faComments,
	faEraser,
	faExchangeAlt,
	faFlagCheckered,
	faGear,
	faPaperclip,
	faPenToSquare,
	faQuestion,
	faTerminal,
} from "@fortawesome/free-solid-svg-icons";
import { IExtendedActionItem, TExtendedAction } from "./FormAddingAction.props";
import { ACTION_LIST } from "@/constants/robotConfigLists";

export const ACTION_ICONS: Record<TExtendedAction, IconDefinition> = {
	say: faCommentDots,
	confirmation: faCheck,
	sendfile: faPaperclip,
	setvariable: faGear,
	goto: faArrowRight,
	break: faBan,
	transfer: faExchangeAlt,
	declinedata: faEraser,
	end: faFlagCheckered,
	"qas-chat": faComments,
	"qas-ask": faQuestion,
	external: faTerminal,
	chooseAction: faPenToSquare,
	setreport: faChartLine,
};

export const EXTENDED_ACTION_LIST: IExtendedActionItem[] = [
	{ value: "chooseAction", label: "selectItem_selectAction" },
	...ACTION_LIST.map((el) => ({ value: el.action, label: el.translation })),
	{ value: "qas-chat", label: "selectItem_llmChat" },
	{ value: "qas-ask", label: "selectItem_qasRequest" },
	{ value: "external", label: "selectItem_runScript" },
];
